// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../types';
import {
  generateVariantsCss,
  justifyContent,
} from './helpers';

export const Caret = css`
  &:after {
    border-style: solid;
    border-width: 0 0 1px 1px;
    content: '';
    display: inline-block;
    height: .25rem;
    width: .25rem;
    transform: rotateZ(225deg) translate(-2px, 0);
  }`;

export default styled<any, Theme>('button')`
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: ${props => (props.rounded ? '3em' : `${props.theme.buttons.borderRadius}`)};
  ${props => props.onClick && 'cursor: pointer'};
  margin: ${props => (props.hasMargin ? '0 0 1rem 0' : '0')};
  font-family: ${props => (props.theme.buttons.fontFamily ? props.theme.buttons.fontFamily : 'inherit')};
  font-weight: ${props => props.theme.buttons.fontWeight};
  font-size: ${props => props.theme.buttons.fontSize};
  line-height: 1.5rem;
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  justify-content: ${props => justifyContent(props.position)};
  text-transform: ${props => props.theme.buttons.textTransform || 'none'};
  min-width: ${props => props.theme.buttons.minWidth};
  ${props => props.fullWidth && 'width: 100%'};
  box-sizing: border-box;
  outline: none;
  text-decoration: none;

  ${props => props.caret && Caret}

  ${props => generateVariantsCss(props.variant)(props.colors, props)}
  &:disabled {
    ${props => generateVariantsCss(props.variant)('disabled', props)}
    cursor: not-allowed;
  }
`;
